import { PageLayout } from 'components/PageLayout';

export const Create: React.FC = () => {
  return <PageLayout withBackButton title="New sale"></PageLayout>;
};
